<template>
  <div class="page vh100 grid grid-columns-4_md align-content-center z10 relative c1 grey-250">
    <transition
      :name="transitionName"
      mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import Overlay from '../livewires/Overlay'

export default {
  components: {
    lwOverlay: Overlay
  },
  data () {
    return {
      transitionName: 'slide-left'
    }
  },
  watch: {
    '$route' (to, from) {
      const toArray = to.path.split('/')
      const toStep = toArray[2]
      const fromArray = from.path.split('/')
      const fromStep = fromArray[2]
      if (toStep > fromStep) {
        this.transitionName = 'slide-left'
      } else {
        this.transitionName = 'slide-right'
      }
    }
  }
}
</script>

<style scoped>
  .page {
    z-index: 1100;
    margin-top: calc(var(--line) * -1.5);
  }
  @media screen and (min-width: 48em) {
    .page {
      margin-top: calc(var(--line) * -1.5);
    }
  }
</style>
